module.exports = __webpack_public_path__ + "24339f20eba58bc7170659f1445273b5.pdf";